<div *ngIf="modalData?.title" class="modal-header">
  <h5 class="modal-title" id="myModalLabel">{{modalData?.title}}</h5>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeDialog()"></button>
</div>
<div class="modal-body">
  <h5 *ngIf="modalData?.subTitle">{{modalData?.subTitle}}</h5>
  <div *ngIf="modalData?.shortDescription" [innerHTML]="modalData?.shortDescription"></div>
  <div *ngIf="modalData?.description" [innerHTML]="modalData?.description"></div>
</div>
<div class="modal-footer">
  <button (click)="closeDialog()" type="button" class="btn btn-secondary waves-effect"
    data-bs-dismiss="modal">Close</button>
  <!--  <button type="button" class="btn btn-primary waves-effect waves-light">Save changes</button> -->
</div>